import { render, staticRenderFns } from "./user_new_rank_percentage.vue?vue&type=template&id=ad9d3cfa&scoped=true&"
import script from "./user_new_rank_percentage.vue?vue&type=script&lang=js&"
export * from "./user_new_rank_percentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9d3cfa",
  null
  
)

export default component.exports